<template>
  <div >

        <section >
                <div class="">
                    <!-- Mobile action buttons -->
                    <div class="d-flex d-md-none gap-2 mb-3" v-if="!isDetailSupplier">
                        <button @click="create" v-if="helper.checkAccess('create_purchases') != -1" class="btn btn-sm btn-success flex-grow-1">
                            <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                            <span>{{$t('purchase')}}</span>
                        </button>
                    </div>

                    <!-- Filters section -->
                    <div class="row align-items-end g-2 mb-4" v-if="!isDetailSupplier" :class="{'d-none d-md-flex': !showFilters}">
                        
                        <!-- Filter Dropdown (Shopify Style) -->
                        <div class="col-12 col-md-auto">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="purchaseFilterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-funnel" class="bi bi-funnel" /> {{$t('filter')}}
                                    <span v-if="activeFilters.length" class="badge bg-secondary ms-1">{{activeFilters.length}}</span>
                                </button>
                                <button v-if="activeFilters.length" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" />{{$t('clear_all')}}
                                </button>
                                <div class="dropdown-menu p-3" aria-labelledby="purchaseFilterDropdown" style="min-width: 300px;" @click.stop>
                                    
                                    <!-- Active Filters -->
                                    <div v-if="activeFilters.length > 0" class="mb-3">
                                        <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                            <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                                            <div class="input-group input-group-sm" v-if="filter.key === 'total_amount'">
                                                <select v-model="filter.operator" class="form-select" style="max-width: 80px;">
                                                    <option value="gt">{{$t('operator_gt')}}</option>
                                                    <option value="lt">{{$t('operator_lt')}}</option>
                                                    <option value="eq">{{$t('operator_eq')}}</option>
                                                </select>
                                                <input type="number" v-model="filter.value" class="form-control form-control-sm" placeholder="0">
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                            <div class="input-group input-group-sm" v-else>
                                                <select v-model="filter.value" class="form-select form-select-sm">
                                                    <option v-for="option in getFilterOptions(filter.key)" :key="option.value" :value="option.value">
                                                        {{$t(option.label)}}
                                                    </option>
                                                </select>
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                        </div>
                                        <hr class="dropdown-divider">
                                    </div>

                                    <!-- Add Filter Options -->
                                    <div class="d-grid gap-2">
                                        <button v-for="filter in selectableFilters" :key="filter.key" 
                                                class="btn btn-sm btn-outline-primary text-start" 
                                                @click="addFilter(filter)">
                                            <AppIcon name="bi-plus" class="bi bi-plus" /> {{$t(filter.key)}}
                                        </button>
                                    </div>

                                    <!-- Apply and Clear -->
                                    <div class="d-flex justify-content-between align-items-center mt-3">
                                        <button class="btn btn-sm btn-success" @click="applyFilters">
                                            {{$t('apply')}}
                                        </button>
                                        <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">
                                            {{$t('clear_all')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Spacer for desktop -->
                        <div class="col d-none d-md-block"></div>
                        
                        <!-- Date picker -->
                        <div class="col-12 col-md-3 col-lg-2">
                            <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                            <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                <option value="">{{$t('filter_by_date')}}</option>
                                <option value="today">{{$t('today')}}</option>
                                <option value="yesterday">{{$t('yesterday')}}</option>
                                <option value="this_week">{{$t('this_week')}}</option>
                                <option value="last_week">{{$t('last_week')}}</option>
                                <option value="this_month">{{$t('this_month')}}</option>
                                <option value="custom">{{$t('custom_date')}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                            <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                            <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                        
                        <!-- Desktop action buttons -->
                        <div class="col-md-2 d-none d-md-block" v-if="helper.checkAccess('create_purchases') != -1">
                            <button @click="create" class="btn btn-sm btn-success w-100">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('purchase')}}</span>
                            </button>
                        </div>
                    </div>
                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- Bulk Action Bar -->
                    <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
                        <div class="d-flex align-items-center">
                            <span class="fw-bold me-2">{{ selectedCount }}</span>
                            <span class="text-muted">{{$t('selected')}}</span>
                        </div>
                        <div class="d-flex gap-2">
                            <div v-if="helper.checkAccess('create_receptions') > 0" class="dropdown dropup">
                                <button class="btn btn-primary btn-sm dropdown-toggle d-flex align-items-center" type="button" id="bulkTransferDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-arrow-left-right" class="bi bi-arrow-left-right me-1" /> {{$t('transfert')}}
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="bulkTransferDropdown">
                                    <li><a class="dropdown-item" style="cursor:pointer" @click="transferSelectedToReception"> {{$t('reception')}}</a></li>
                                </ul>
                            </div>
                            <button v-if="helper.checkAccess('delete_purchases') != -1" class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                                <AppIcon name="bi-trash" class="bi bi-trash me-1" /> {{$t('delete')}}
                            </button>
                        </div>
                    </div>

                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                                        </div>
                                    </th>
                                    <sortable-table-header field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPurchases)" />
                                    <sortable-table-header field="total" label="total" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPurchases)" />
                                    <th class="pt-4 pb-3 px-6">{{$t('total_products')}}</th>
                                    <sortable-table-header v-if="!hideSupplier" field="supplier" label="supplier" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPurchases)" />
                                    <sortable-table-header field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPurchases)" />
                                    <sortable-table-header field="date" label="date" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPurchases)" />
                                    <sortable-table-header field="created_by" label="created_by" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getPurchases)" />
                                    <th class="pt-4 pb-3 px-6">{{$t('action')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="purchase in purchases" :key="purchase.id" :class="{'table-active': purchase.selected}">
                                <td class="py-5 px-6">
                                    <div class="form-check mb-0">
                                        <input class="form-check-input" type="checkbox" v-model="purchase.selected" @change="changeSelectedItem">
                                    </div>
                                </td>
                                <td class="py-5 px-6"><router-link v-if="purchase.reference && purchase.reference" :to="`/purchases/${purchase.id}`"><b>{{ purchase.reference }}</b></router-link></td>
                                <td class="py-5 px-6">{{formatMoney(calculateItemPrice(purchase))}} </td>
                                <td class="py-5 px-6">{{purchase.products.length}}</td>
                                <td v-if="!hideSupplier" class="py-5 px-6"> <router-link v-if="purchase.supplier && purchase.supplier.id" :to="`/suppliers/${purchase.supplier.id}`">{{purchase.supplier && purchase.supplier.name ? purchase.supplier.name : '-'}}</router-link></td>
                                <td class="py-5 px-6">
                                    <div v-if="helper.checkAccess('edit_purchases') != -1" class="dropdown">
                                        <button
                                            :id="`purchase-status-${purchase.id}`"
                                            type="button"
                                            class="badge border-0 dropdown-toggle"
                                            :class="getPurchaseStatusBadgeClass(purchase.status)"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            :disabled="isPurchaseStatusDropdownDisabled(purchase)"
                                        >
                                            <span v-if="statusUpdatingPurchaseId === purchase.id" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            {{ $t(purchase.status) }}
                                        </button>
                                        <ul class="dropdown-menu shadow" :aria-labelledby="`purchase-status-${purchase.id}`">
                                            <li v-for="status in getPurchaseStatusOptions()" :key="status">
                                                <button
                                                    type="button"
                                                    class="dropdown-item d-flex align-items-center justify-content-between gap-3"
                                                    :class="{ active: purchase.status === status }"
                                                    @click="changePurchaseStatus(purchase, status)"
                                                >
                                                    <span>{{ $t(status) }}</span>
                                                    <AppIcon name="bi-check-lg" v-if="purchase.status === status" class="bi bi-check-lg" />
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <span v-else class="badge" :class="getPurchaseStatusBadgeClass(purchase.status)">
                                        {{ $t(purchase.status) }}
                                    </span>
                                </td>
                                <td class="py-5 px-6">{{formatDate(purchase.date)}}</td>
                                <td class="py-5 px-6">
                                    {{purchase.user ? purchase.user.name : '-'}}
                                </td>
                                <td class="py-5 px-6">
                                    <a :href="'/purchases/'+purchase.id" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-eye" class="bi bi-eye" />
                                        {{$t('details')}}
                                    </a>
                                    <button  v-if="false" @click="showReceptions(purchase)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        {{$t('receptions')}}
                                    </button>
                                    <button v-if="false" @click="showPayments(purchase)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        {{$t('payments')}}
                                    </button>
                                    <button v-if="purchase.status != 'draft'" @click="viewRow(purchase)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                        {{$t('purchase_order')}} 
                                    </button>
                                    <button v-if="helper.checkAccess('edit_purchases') != -1" @click="editRow(purchase)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                                    </button>
                                    <button v-if="helper.checkAccess('delete_purchases') != -1" @click="deleteRow(purchase)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                                    </button>
                    
                                </td>
                            </tr>
                            <tr v-if="purchases.length" style="background-color: #f8f9fa;font-weight: bold">
                                <td>{{$t('total')}}:</td>
                                <td></td>
                                <td class="py-5 px-6">{{formatMoney(purchases.reduce((acc, item) => acc + calculateItemPrice(item), 0))}} </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>   
                            </tr>
                            </tbody>
                        </table>

                        <div v-if="count > purchases.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getPurchases" />
                        </div>
                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !purchases.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-bag" class="bi bi-bag text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_purchases_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_purchases') }}</p>
                        <template v-if="helper.checkAccess('create_purchases') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create">
                                {{ $t('create_first_purchase') }}
                            </button>
                        </template>
                    </div>
                    <div v-if="loading === false && !purchases.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_purchase_found')}}.</div>

                </div>
                
                <div class="col-sm-7">
                           {{$t('show')}}
                            <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            {{$t('entities')}}
                </div>
                </div>
        </section>

    

        <!-- create Modal -->
        <add-edit-purchase-modal 
            v-if="createModalPurchaseIsOpen" 
            @modalClosed="createModalPurchaseIsOpen = false"
            modalId="create-purchase-modal-01" 
            :isModalOpen="createModalPurchaseIsOpen" 
            :data="purchase" 
            action="create"
            @refresh="refresh"
        ></add-edit-purchase-modal>
        <!-- create modal -->

        <!-- Edit Modal -->
        <add-edit-purchase-modal 
            v-if="editModalPurchaseisOpen" 
            @modalClosed="editModalPurchaseisOpen = false" 
            modalId="edit-purchase-modal-01" 
            :isModalOpen="editModalPurchaseisOpen"  
            :data="purchase" 
            action="update" 
            @refresh="refresh"
        ></add-edit-purchase-modal>
        <!-- Edit modal -->

        <!-- quote modal -->
        <invoice-template-modal 
            v-if="invoiceModalPurchaseIsOpen" 
            @modalClosed="invoiceModalPurchaseIsOpen = false" 
            modalId="invoice-purchase-modal-01" 
            :isModalOpen="invoiceModalPurchaseIsOpen"  
            :data="purchase" 
            type="purchase">
        </invoice-template-modal>
        <!-- quote modal -->

        <!-- create Modal -->
        <add-edit-reception-modal 
            v-if="createReceptionModalState" 
            @modalClosed="createReceptionModalState = false"
            modalId="create-reception-modal-01" 
            :isModalOpen="createReceptionModalState" 
            :data="purchase" 
            action="transfer"
        ></add-edit-reception-modal>
        <!-- create modal -->

  </div>
</template>

<script>
import helper from '../helper'
import moment from 'moment'
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import AddEditPurchaseModal from './purchase/AddEditPurchaseModal'
import AddEditReceptionModal from './reception/AddEditReceptionModal'
import InvoiceTemplateModal from './invoiceLayout/InvoiceTemplateModal';
import sortableList from '../mixins/sortableList';

export default {
  name: 'Purchase',
  persistedFilterState: {
    key: 'purchases',
    fields: ['activeFilters', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components : {
    DatePicker,
    AddEditPurchaseModal,
    AddEditReceptionModal,
    InvoiceTemplateModal
   },
   props : [
    'openCreateModal',
    'supplier_id',
    'supplier',
    'keyword',
    'isDetailSupplier',
    'showFilters',
    'product_id'
   ],
  data(){
    return {
        loading : false,
        statusUpdatingPurchaseId: null,
        search :'',
        purchases : [],
        count : 0,
        page : 1,
        products : [],
        transactions : [],
        purchase : {
            id : null,
            reference : `PURCHASE-00`,
            date : '',
            notes : '',
            products : [],
            supplier_id : null,
            payment_method : 'cash',
            status : 'pending',
            rest : 0,
            total : 0,
            amount_paid : 0,
        },
        range: [],
        start : null,
        end : null,
        dateRangeOption: '',
        activeFilters: [],
        availableFilters: [
            { 
                key: 'status', 
                options: [
                    { value: 'draft', label: 'draft' },
                    { value: 'pending', label: 'pending' },
                    { value: 'confirmed', label: 'confirmed' }
                ] 
            },
            {
                key: 'total_amount',
                options: []
            }
        ],
        totalHtPrice : 0,
        createModalPurchase : null,
        editModalPurchase : null,
        invoiceModalPurchaseIsOpen : false,
        createModalPurchaseIsOpen :false,
        editModalPurchaseisOpen :false,
        purchasePrice : 0,
        amount : 0,
        createSuplierState : false,
        per_page : 25,
        pagination : [],
        showReception : null,
        showReceptionsModalisOpen : false,
        reception : {
            id : null,
            reference : `RECEPTION-00`,
            date : '',
            notes : '',
            products : [],
            purchase_id : null,
            status : 'pending',
        },
        payment : {
            id : null,
            reference : `PAYMENT-00`,
            date : '',
            notes : '',
            products : [],
            client_id : null,
            client : {},
            payment_method : 'cash',
            status : 'pending',
            rest : 0,
            total : 0,
            amount_paid : 0,
        },
        payments : [],
        receptions : [],
        showPayment :  null,
        showPaymentsModalisOpen : false,
        hideSupplier : false,
        url : '',
        isSelectedItem: false,
        createReceptionModalState: false
    }
  },
  mounted(){
    // Initialize this_month date range
    // this.handleDateRangeChange()
    
    this.getPurchases()

  },
  watch : {
    range(val) {
        if (val && val.length === 2 && val[0] && val[1]) {
            this.start = moment(val[0]).format('YYYY-MM-DD')
            this.end = moment(val[1]).format('YYYY-MM-DD')
            this.getPurchases(1)
        } else {
            this.start = null
            this.end = null
            this.getPurchases(1)
        }
    },
    per_page(){
        this.getPurchases(this.page)
    },
    openCreateModal(){
        this.createModalStatus = this.openCreateModal
        this.create()
    },
    createModalPurchaseIsOpen(){
        this.getPurchases()
        this.$emit('createModalStatus',this.createModalisOpen)
    },
    async keyword(){
        if(this.keyword.length > 2){
            const response = await helper.customGet(`${process.env.VUE_APP_API}/purchases?keyword=${this.keyword}&per_page=${this.per_page}`)
            this.purchases = response.data.data
            this.count = response.data.count
        }
        if(this.keyword == '') return this.getPurchases()
    }
  },    
  methods : {
    async create(){

        this.clearForm() 
        
        if(this.supplier){
            this.purchase.supplier = this.supplier
        }

        if(this.supplier_id){
            this.purchase.supplier_id = this.supplier_id
        }

        this.createModalPurchaseIsOpen = true;
        this.purchase.date = moment().format('YYYY-MM-DD')
        this.purchase.products.push({
            label : '',
            id : '',
            quantity : 0,
            price : 0,
            discount : 0,
            vat :  0,
            total : 0,
            sub_total : 0,
        })
    },
    editRow(row){
        this.editModalPurchaseisOpen = true;
        this.clearForm()
        this.purchase = row 
        this.purchase.supplier_id = row.supplier && row.supplier.id ? row.supplier.id : null
        this.purchase.date = moment(this.purchase.date).format('YYYY-MM-DD')
    },
    //create purchase
    async saveRow(){
        try{
            this.loading = true
            this.purchase.products = helper.formatProducts(this.purchase.products)
            await helper.customPost(`${process.env.VUE_APP_API}/purchases`, {...this.purchase,  transaction : {amount : this.purchase.amount_paid}, products : [...this.purchase.products]},{showToast:true})
            this.loading = false
            this.getPurchases()
            this.clearForm()
            this.createModalPurchase.hide()
        }catch(error){
            this.loading = false
        }

    },
    //update purchase
    async updateRow(){
        try{
            this.loading = true
            this.purchase.products = helper.formatProducts(this.purchase.products)
            await helper.customPatch(`${process.env.VUE_APP_API}/purchases/${this.purchase.id}`,{...this.purchase,transaction : {amount : this.purchase.amount_paid}, products : [...this.purchase.products]})
            this.loading = false
            this.clearForm()
            this.editModalPurchase.hide()
            this.getPurchases()
        }catch(error){
            this.loading = false
        }

    },
    viewRow(row){
        this.clearForm()
        this.purchase = row 
        this.invoiceModalPurchaseIsOpen = true;
    },
    previewRow(){
        this.invoiceModalPurchaseIsOpen = true;
    },
    async deleteRow(row){
        this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text : this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
            if (result.isConfirmed) {
                await helper.customDelete(`${process.env.VUE_APP_API}/purchases/${row.id}`)
                this.purchases = helper.withoutDeletedRecords(this.purchases, row.id)
                this.count = Math.max(0, this.count - 1)
            }
        })
    },
    clearForm(){
        this.purchase = {
            id : null,
            reference : '',
            date : '',
            products : [],
            payment_method : 'cash',
            status : 'pending',
            rest : 0,
            total : 0,
            amount_paid : 0,
        }

    },
    async getPurchases(page){
        try{
            this.loading = true
            this.page = page ? page : 1
            
            // Extract filters
            const statusFilter = this.activeFilters.find(f => f.key === 'status');
            const status = statusFilter ? statusFilter.value : 'all';

            const amountFilter = this.activeFilters.find(f => f.key === 'total_amount');

            // Build query params
            const params = new URLSearchParams();
            params.append('page', this.page);
            params.append('per_page', this.per_page);
            this.appendSortParams(params);

            if (this.start) {
                params.append('start', this.start);
                params.append('end', this.end);
            }

            if (status !== 'all') params.append('status', status);
            
            if (amountFilter && amountFilter.value !== null && amountFilter.value !== '') {
                params.append('amount_operator', amountFilter.operator);
                params.append('amount_value', amountFilter.value);
            }
            
            // Add optional filters if they exist
            if (this.supplier_id) params.append('supplier_id', this.supplier_id);
            if (this.product_id) params.append('product_id', this.product_id);
            if (this.keyword && this.keyword.length > 2) params.append('keyword', this.keyword);

            let url = `${process.env.VUE_APP_API}/purchases?${params.toString()}`;

            const response = await helper.customGet(url)
            this.purchases = response.data.data
            for(let i = 0 ; i < this.purchases.length ; i++){
                this.$set(this.purchases[i], 'selected', false)
            }
            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }
            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }
            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    calculatePrices(){
        this.$forceUpdate();
        for(let i = 0 ; i < this.purchase.products.length ; i++){
            this.purchase.products[i].total = parseFloat(this.purchase.products[i].price) * parseFloat(this.purchase.products[i].quantity)

            this.purchase.products[i].sub_total = Math.round(parseFloat(this.purchase.products[i].total))
            if(this.purchase.products[i].vat > 0){
                this.purchase.products[i].total += parseFloat((this.purchase.products[i].total * (parseFloat(this.purchase.products[i].vat) / 100)).toFixed(2))
                this.purchase.products[i].total = Math.round(this.purchase.products[i].total)
            }
        }

        this.purchase.total = this.purchase.products && this.purchase.products.length ? this.purchase.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0;
        this.totalHtPrice = this.purchase.products && this.purchase.products.length ? this.purchase.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0;
        this.purchasePrice = this.purchase.products && this.purchase.products.length ? this.purchase.products.map(o => o.purchase_price).reduce((a, c) => { return a + c }) : 0;
    },
    parseTTctoHt(index,price){
        if(price && price > 0){
           this.purchase.products[index].price = ((price / this.purchase.products[index].quantity) / 1.2).toFixed(2)
           this.purchase.products[index].sub_total = parseFloat(this.purchase.products[index].price) * parseFloat(this.purchase.products[index].quantity)
        }
    },
    calculateItemPrice(purchase){
        if(purchase.status == "draft") return 0
        return purchase.products && purchase.products.length ? purchase.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0; 
    },
    calculateProfits(purchase){
        let profit = 0
        for(let i = 0 ; i < purchase.products.length ; i++){
            profit+= purchase.products[i].total - (purchase.products[i].purchase_price * purchase.products[i].quantity)  
        }
        return profit
    },
    emitAutoComplete(data){
        if(!this.localData.products.length || !this.localData.products.find(product => product.product_id == data.result.product.id)){
            this.purchase.products[data.index] = {
                ...{
                inventory_id : data.result.id,
                label : data.result.product.label,
                product_label : data.result.product.label,
                id : data.result.product.id,
                product_id : data.result.product.id,
                quantity : 0, 
                maxQty : data.result.quantity,
                price : data.result.price,
                purchase_price : data.result.purchase_price ? data.result.purchase_price : 0,
                vat :  0,
                total : data.result.total ? data.result.total : 0,
                sub_total : data.result.sub_total ? data.result.sub_total : 0,
            }}
            this.purchase.products = [...this.purchase.products]

            // for(let i = 0 ; i < this.purchase.products.length ; i++){
            //     this.purchase.products[i].maxQty = this.purchase.products[i].quantity;
            // }

            this.calculatePrices()
        }
    },
    emitAutoCompleteSupplier(data){
        this.purchase.supplier_id = data.result.id
        this.purchase.supplier = data.result
    },
    getStatus(status){
       if(status == 'paid'){
         return 'badge bg-success rounded-pill small'
       }else if(status == 'partially_paid'){
         return 'badge bg-success rounded-pill small'
       }else if(status == 'pending'){
         return 'badge bg-primary rounded-pill small'
       }else if(status == 'refunded'){
         return 'badge bg-info rounded-pill small'
       }
    },
    getPurchaseStatusBadgeClass(status){
        return {
            'bg-info': status === 'draft',
            'bg-success': status === 'completed' || status === 'received' || status === 'confirmed',
            'bg-warning': status === 'partially_received',
            'bg-danger': status === 'canceled',
            'bg-secondary': status === 'pending'
        }
    },
    getPurchaseStatusOptions(){
        const filter = this.availableFilters.find(filter => filter.key === 'status')
        return filter ? filter.options.map(option => option.value) : []
    },
    isPurchaseStatusDropdownDisabled(purchase){
        return this.statusUpdatingPurchaseId === purchase.id
    },
    async changePurchaseStatus(purchase, status){
        if (this.isPurchaseStatusDropdownDisabled(purchase) || purchase.status === status) return

        const toggle = document.getElementById(`purchase-status-${purchase.id}`)
        if (toggle) {
            // eslint-disable-next-line no-undef
            const dropdown = bootstrap.Dropdown.getInstance(toggle)
            if (dropdown) dropdown.hide()
        }

        const previousStatus = purchase.status
        this.statusUpdatingPurchaseId = purchase.id
        this.$set(purchase, 'status', status)

        try{
            await helper.customPatch(
                `${process.env.VUE_APP_API}/purchases/${purchase.id}`,
                { status },
                { showToast: true }
            )
        }catch(error){
            this.$set(purchase, 'status', previousStatus)
        }finally{
            await this.getPurchases(this.page)
            this.statusUpdatingPurchaseId = null
        }
    },
    createSupplier(data){
        if(data.supplier){
            this.purchase.supplier_id = data.supplier.id
            this.purchase.supplier = data.supplier
        }
        if(data && data.state != undefined){
            this.createSuplierState = data.state
        }
    },
    openCreateSupplierModal(){
        this.createSuplierState = !this.createSuplierState
    },
    generatePDF() {
        const doc = new jsPDF();

        const data = []
        for(let i = 0 ; i < this.purchases.length ; i++){
            const purchase = this.purchases[i]
            
            data.push([
                purchase.reference,
                `${this.formatMoney(this.calculateItemPrice(purchase))}`,
                purchase.products.length,
                purchase.supplier && purchase.supplier.name ? purchase.supplier.name : '-',
                this.formatDate(purchase.date)
            ])
        }
        doc.text("Achats", 15, 10);
        autoTable(doc,
        {
            head: [["Id", "Total(ttc)","Total Des Produits", "Fournisseur","Date d'achat"]],
            body: data
        })
        doc.save('achats.pdf')
    },
    generateCsv(){
        const data = []
        for(let i = 0 ; i < this.purchases.length ; i++){
            const purchase = this.purchases[i]
            data.push({
                "Id" : purchase.id,
                "Total(ttc)" : `${this.formatMoney(this.calculateItemPrice(purchase))}` ,
                "Total Donnée" : `${this.formatMoney(purchase.amount_paid)}`,
                "Rest" : `${this.formatMoney(purchase.total - purchase.amount_paid)}`,
                "Status" : this.$t(purchase.status),
                "Mode de paiment" : this.$t(purchase.payment_method),
                "Fournisseur" : purchase.client && purchase.client.name ? purchase.client.name : '-',
                "Date d'achat" : this.formatDate(purchase.date)
            })
        }
        return data
    },
    async showPayments(purchase){
        this.purchase = purchase
        this.showPaymentsModalisOpen = true
    },
    async showReceptions(purchase){
        this.purchase = purchase
        this.showReceptionsModalisOpen = true
        // await this.getReceptions(purchase.id)
    },
    refresh(){
        this.getPurchases()
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);},
    // Handle date range selection
    handleDateRangeChange() {
      const option = this.dateRangeOption
      if (!option || option === 'custom') {
        if (option === 'custom') return
        this.range = []
        this.start = null
        this.end = null
        this.getPurchases()
        return
      }

      const today = moment()
      let start, end

      switch(option) {
        case 'today':
          start = today.clone().startOf('day')
          end = today.clone().endOf('day')
          break
        case 'yesterday':
          start = today.clone().subtract(1, 'days').startOf('day')
          end = today.clone().subtract(1, 'days').endOf('day')
          break
        case 'this_week':
          start = today.clone().startOf('isoWeek')
          end = today.clone().endOf('isoWeek')
          break
        case 'last_week':
          start = today.clone().subtract(1, 'weeks').startOf('isoWeek')
          end = today.clone().subtract(1, 'weeks').endOf('isoWeek')
          break
        case 'this_month':
          start = today.clone().startOf('month')
          end = today.clone().endOf('month')
          break
        default:
          return
      }

      this.range = [start.toDate(), end.toDate()]
      this.start = start.format('YYYY-MM-DD')
      this.end = end.format('YYYY-MM-DD')
      this.getPurchases()
    },
    addFilter(filter) {
        if (!this.isFilterActive(filter.key)) {
            if (filter.key === 'total_amount') {
                 this.activeFilters.push({
                    key: filter.key,
                    operator: 'gt',
                    value: 0
                });
            } else {
                const defaultVal = filter.options[0].value;
                this.activeFilters.push({ 
                    key: filter.key, 
                    value: defaultVal 
                });
            }
        }
    },
    removeFilter(index) {
        this.activeFilters.splice(index, 1);
    },
    isFilterActive(key) {
        return this.activeFilters.some(f => f.key === key);
    },
    getFilterOptions(key) {
        const filter = this.availableFilters.find(f => f.key === key);
        return filter ? filter.options : [];
    },
    applyFilters() {
        this.getPurchases();
    },
    clearAllFilters() {
        this.activeFilters = [];
        this.getPurchases();
    },
    changeSelectedItem(){
        this.isSelectedItem = this.purchases.find(item => item.selected === true ) ? true : false
    },
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.purchases.forEach(item => item.selected = newState);
      this.changeSelectedItem();
    },
    async deleteSelected() {
      const selectedIds = this.purchases.filter(item => item.selected).map(item => item.id);
      if (selectedIds.length === 0) return;

      this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async (result) => {
        if (result.isConfirmed) {
            this.loading = true;
            try {
                const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/purchases/${id}`)));
                const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
                this.purchases = helper.withoutDeletedRecords(this.purchases, deletedIds);
                this.count = Math.max(0, this.count - deletedIds.length);
                if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
                this.isSelectedItem = false;
                this.$toast.open({
                    message: this.$t('purchases_deleted_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            } finally {
                this.loading = false;
            }
        }
      });
    },
    validateBulkTransfer() {
        const selectedPurchases = this.purchases.filter(item => item.selected);
        if (selectedPurchases.length === 0) return null;

        const supplierId = selectedPurchases[0].supplier_id;
        const allSameSupplier = selectedPurchases.every(o => o.supplier_id === supplierId);

        if (!allSameSupplier) {
            this.$swal.fire(
                this.$t('error'),
                this.$t('select_purchases_same_supplier'),
                'error'
            );
            return null;
        }
        
        // Aggregate products
        let allProducts = [];
        selectedPurchases.forEach(o => {
            if (o.products && o.products.length) {
                allProducts = allProducts.concat(o.products);
            }
        });

        // Calculate total
        const total = allProducts.reduce((acc, p) => acc + (p.total || 0), 0);

        return {
            id: null,
            purchase_ids: selectedPurchases.map(o => o.id),
            supplier_id: supplierId,
            status : 'pending',
            supplier: selectedPurchases[0].supplier,
            date: moment().format('YYYY-MM-DD'),
            products: allProducts,
            total: total
        };
    },
    transferSelectedToReception() {
        const mergedData = this.validateBulkTransfer();
        if (!mergedData) return;

        this.purchase = mergedData;
        this.createReceptionModalState = true;
    }
  },
  computed : {
    selectableFilters() {
        return this.availableFilters.filter(f => !this.isFilterActive(f.key));
    },
    isFiltered() {
      return (this.activeFilters.length > 0) ||
             (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.keyword && this.keyword.length > 0) ||
             (this.range && this.range.length > 0);
    },
    business(){ return this.$store.getters.BUSINESS},
    helper(){ return helper },
    role(){ return this.$store.getters.ROLE },
    permissions(){ return this.$store.getters.PERMISSIONS },
    total(){ return this.purchase.products.length ? this.purchase.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.purchase.products.length ? this.purchase.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
    selectedCount() {
      return this.purchases.filter(item => item.selected).length;
    },
    areAllSelected() {
      return this.purchases.length > 0 && this.purchases.every(item => item.selected);
    }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
